"use strict";

ZDT.Analytics = {
    trackLink: function(e) {
        var data = $(e.currentTarget).data().gaParams;
        ga("send", {
            hitType: "event",
            // Required.
            eventCategory: data.category,
            // Required.
            eventAction: "click",
            // Required.
            eventLabel: data.label,
            eventValue: data.value
        });
    },

    /**
     * Трекер показов виджета
     * @param  {HTMLElement} el HTML-объект (node) виджета
     */
    trackWidgetShow: function(el) {
        var data = $(el).data().gaParams;
        ga("send", {
            hitType: "event",
            // Required.
            eventCategory: data.category,
            // Required.
            eventAction: "show",
            // Required.
            nonInteraction: 0
        });
    }
};
ZDT.galleryOptions = {
    delegate: ".js-popup",
    centerMode: true,
    type: "image",
    closeOnContentClick: false,
    closeBtnInside: false,
    mainClass: "mfp-with-zoom mfp-img-mobile",
    image: {
        verticalFit: true
    },
    gallery: {
        enabled: true
    }
};

ZDT.getCookie = function(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
};

$(document).on("click", "[data-ga-track-link]", ZDT.Analytics.trackLink);
$('[data-toggle="popover"]').popover();
$("[data-toggle-delay]").popover({
    delay: {
        "hide": 2000
    }
}); // for adding bundle in to cart

$(document).on('mousedown', '.add_bundle', function() {
    var product_id = $(this).data('product-id');
    $.ajax({
        type: 'POST',
        url: '/cart/add',
        dataType: 'json',
        data: {
            id: product_id,
            quantity: 1
        },
        success: function() {
            window.location.href = "/cart";
        }
    });
});
$(document).on("click", "[data-toggle-discount]", function(e) {
    e.preventDefault();
    $("[data-discount]").toggleClass("hidden");
});

if ($(window).width() < 1280) {
    $('.dropdown-services').attr('data-toggle', 'dropdown');
}

var $dropdownServices = $(".dropdown-services");
$(window).on('scroll resize', function() {
    if ($(window).width() > 1280) {
        $dropdownServices.removeAttr('data-toggle', 'dropdown');
    }
});
$(window).trigger("resize scroll");
$(function() {
    var $cookiesBar = $("[data-cookies-bar]");
    var $cookiesButton = $("[data-cookies-button]");

    if (!localStorage.getItem("hideCookiesBar")) {
        $("<div />", {
            "data-temp-block": "",
            style: "height: " + $cookiesBar.outerHeight() + "px"
        }).insertAfter(".footer");
        $cookiesBar.show();
        $cookiesButton.on("click", function() {
            $("[data-temp-block]").addClass("hidden");
            $cookiesBar.addClass("closed");
            setTimeout(function() {
                $cookiesBar.hide();
                $("[data-temp-block]").remove();
            }, 500);
            localStorage.setItem("hideCookiesBar", true);
        });
    }
});
$(window).on("scroll resize", function() {
    if ($("#navbar-collapse").hasClass("in")) {
        $("#navbar-collapse").collapse("hide");
    }
});
$(window).on("click", function(e) {
    if ($("#navbar-collapse").hasClass("in")) {
        if ($(e.target).closest(".navbar").length == 0) {
            $('html, body').removeClass('hidden-layout');
            $("#navbar-collapse").collapse("hide");
        }
    }
});

var $navbar = $('[data-navbar]');
var $navbarCollapse = $('[data-target="#navbar-collapse"]');

function bannerNav() {
    if ($(window).scrollTop() < $('.case-banner').height()) {
        $navbar.addClass('top');
    } else {
        if ($navbar.is('.top')) {
            $navbar.removeClass('top');
        }
    }
}

bannerNav();
$(window).on("scroll", function() {
    bannerNav();
});
$(document).on('show.bs.collapse', $navbarCollapse, function() {
    $navbar.removeClass('navbar-inverse').addClass('navbar-default');
    $('html, body').addClass('hidden-layout');
    $navbar.addClass('navbar--opened');
});
$(document).on('hide.bs.collapse', $navbarCollapse, function() {
    if ($(window).scrollTop() < $('.case-banner').outerHeight()) {
        $navbar.removeClass('navbar-default').addClass('navbar-inverse');
    }

    $navbar.removeClass('navbar--opened');
    $('html, body').removeClass('hidden-layout');
}); // for A/B tests

if ($('.old').length > 0) {
    $navbar.addClass('navbar--old');
}

; // open popup

window.addEventListener('DOMContentLoaded', () => {
    const urlParams = new URLSearchParams(window.location.search);
    const openPopup = urlParams.get('withPopup');

    if (openPopup && (openPopup === null || openPopup === void 0 ? void 0 : openPopup.toLowerCase()) === 'true') {
        $("[data-get-quote]").click();
    }
}); //traking Linkedin

function microLinkedinMenu() {
    window.lintrk('track', {
        conversion_id: 9749849
    });
}

function microLinkedinSocial() {
    window.lintrk('track', {
        conversion_id: 9749881
    });
}

function microLinkedinButton() {
    window.lintrk('track', {
        conversion_id: 9749905
    });
}

function macroLinkedinSubmit() {
    window.lintrk('track', {
        conversion_id: 9749857
    });
}

setTimeout(function() {
    $(window).bind('scroll.once', function() {
        macroLinkedinView();
    });
}, 5000);

function macroLinkedinView() {
    window.lintrk('track', {
        conversion_id: 8885012
    });
    $(window).unbind('scroll.once');
}

function macroLinkedinBuy() {
    window.lintrk('track', {
        conversion_id: 9749865
    });
}

function macroLinkedinCheckout() {
    window.lintrk('track', {
        conversion_id: 9749873
    });
}